import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsB2B from '../../../components/video-production/explainer-videos/BenefitsB2B';
import ProcessSliderB2B from '../../../components/sliders/ProcessSliderB2B';
import SolveProblemsB2B from '../../../components/video-production/explainer-videos/SolveProblemsB2B';

lazyload({
  width: '100%',
});

const ExplainerVideosB2B = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - B2B Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/B2B-explainer-video" />
        <meta
          name="description"
          content="B2B explainer videos simplify complex concepts, boosting engagement and conversions for businesses. Find out how with our expert solutions."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/B2B-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - B2B Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="B2B explainer videos simplify complex concepts, boosting engagement and conversions for businesses. Find out how with our expert solutions."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/B2B-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - B2B Explainer Video | Prodigi",
  "description": "B2B explainer videos simplify complex concepts, boosting engagement and conversions for businesses. Find out how with our expert solutions.",
  "url": "https://weprodigi.com/video-production/B2B-explainer-videoo",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "B2B Explainer Video Production",
        "item": "https://weprodigi.com/video-production/realB2B-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "B2B Explainer Video Production",
    "description": "B2B explainer videos simplify complex concepts, boosting engagement and conversions for businesses. Find out how with our expert solutions.",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Yurriana Cstillo"
        },
        "datePublished": "2024-12-20",
        "reviewBody": "B2B explainer videos are exceptional! They effortlessly distill complex business concepts into visually captivating content, making them invaluable for companies seeking clear communication."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Adam Morris"
        },
        "datePublished": "2024-12-21",
        "reviewBody": "Prodigi's mastery in B2B explainer video production shines through in their work. Their videos eloquently communicate the value propositions of businesses, setting them apart in the competitive market landscape."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Zein Smith"
        },
        "datePublished": "2024-02-08",
        "reviewBody": "B2B explainer videos stand out for their clarity and impact! They adeptly simplify intricate business ideas into engaging visuals, offering a powerful tool for businesses aiming to streamline their message."
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
}`,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/B2B-explainer/B2B-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              B2B Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/B2B-explainer-video',
                name: 'B2B Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A B2B explainer video is a new sort of marketing strategy. It’s an effective way to communicate with clear messages. Are you
                  interested in how? Scroll down to learn more about these call-to-action videos.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a B2B Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/47dtFZ8CFo8?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Safe Room | B2B Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                What should a B2B company do to reserve its place in the diverse market? It should improve marketing and trust-building methods. Also,
                don’t forget about good communication. Seems like we can write a long list. But there's one thing that has everything at once. It’s
                the format of B2B animated explainer videos, the helpful solution for different problems.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  What should a B2B company do to reserve its place in the diverse market? It should improve marketing and trust-building methods.
                  Also, don’t forget about good communication. Seems like we can write a long list. But there's one thing that has everything at once.
                  It’s the format of B2B animated explainer videos, the helpful solution for different problems.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use B2B Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              Are you looking for some good changes for your B2B company? Create a straight link with your target audience. Explainer video is the
              change that you need! And it never comes alone. Learn more about how useful it can be in various sectors.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/5o7sSDcca6Q?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Digital Caramel | B2B Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Here’s a new level of improvement for your marketing plans. You can improve it quickly. The secret is good explanations of your
                  services. B2B marketing video will craft the key information and turn it into interactive visual content. It's an easy way to
                  attract your potential customers. The shareable format of videos can take over the virtual world in a short time. An explainer video
                  for B2B marketing strategy will advertise and engage! Simplified information stands as a secret recipe.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Here’s a new level of improvement for your marketing plans. You can improve it quickly. The secret is good explanations of your
                    services. B2B marketing video will craft the key information and turn it into interactive visual content. It's an easy way to
                    attract your potential customers. The shareable format of videos can take over the virtual world in a short time. An explainer
                    video for B2B marketing strategy will advertise and engage! Simplified information stands as a secret recipe.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  How do you improve awareness of your B2B business? There’s a valuable tool for clarifying all the points. Explain B2B marketing with
                  explainer videos. They are ready to present everything about your services. Good explanations will show new tools or platforms that
                  your firm offers. Whiteboard animation for B2B will picture your brand policies and values. They are very effective in employee
                  training courses. This proficient development will give a unique introduction to your firm.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    How do you improve awareness of your B2B business? There’s a valuable tool for clarifying all the points. Explain B2B marketing
                    with explainer videos. They are ready to present everything about your services. Good explanations will show new tools or
                    platforms that your firm offers. Whiteboard animation for B2B will picture your brand policies and values. They are very effective
                    in employee training courses. This proficient development will give a unique introduction to your firm.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/FuCO0RDxcxc?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>De Courten Solutions | B2B Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/4p40OFz2Wys?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Perkin Elmer | B2B Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Customer Service</h3>
                <p className={'mt-16 hidden md:block'}>
                  Enhance your customer service by providing easily accessible information. Of course, there are a lot of ways to do that. But with
                  this one, you can answer all your customers' questions. And clear answers will bring trust into your brand. Also, this method is
                  very good at customer onboarding. This method is a B2B explainer video. Business explainer animation will engage potential customers
                  because it explains your features simply. With service explanation videos, your firm has a strong position in the diverse market.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Enhance your customer service by providing easily accessible information. Of course, there are a lot of ways to do that. But with
                    this one, you can answer all your customers' questions. And clear answers will bring trust into your brand. Also, this method is
                    very good at customer onboarding. This method is a B2B explainer video. Business explainer animation will engage potential
                    customers because it explains your features simply. With service explanation videos, your firm has a strong position in the
                    diverse market.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of B2B Explainer Videos
            </h2>
            <p className={'mt-20'}>
              It takes work to introduce all the benefits of explainer videos. They are handy for different cases. Here are their main benefits.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsB2B />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">Our B2B Video Production Process</h2>
            <ProcessSliderB2B />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR B2B EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How B2B Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>What can bring good explanations to your business? They are a helping hand in promoting your services.</p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsB2B />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your B2B Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How can B2B explainer videos benefit my business?',
                    answer: 'B2B explainer videos are beneficial for introducing your brand’s advantages to potential customers and partners.',
                  },
                  {
                    title: 'Are B2B explainer videos suitable for all industries?',
                    answer: 'With the versatile format, B2B explainer videos can be adapted to suit the specific needs of almost any industry.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'How long should a B2B explainer video be?',
                    answer: 'As a rule, B2B explainer videos last up to 90 seconds.',
                  },
                  {
                    title: 'How can I measure the effectiveness of my B2B explainer video?',
                    answer:
                      'To measure the effectiveness of your B2B explainer video, you need to divide the number of video plays by the number of page visits or impressions. ',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosB2B;
